import React from 'react';
import { Divider } from '@mui/material';
import CurrentWaveRating from 'components/CurrentWaveRating';

import styles from './RatingsCell.module.scss';

type Props = {
  rating: string | undefined;
  loading: boolean;
};

const RatingsCell: React.FC<Props> = ({ rating, loading }) => {
  if (rating) {
    return <CurrentWaveRating direction="VERTICAL" rating={rating} />;
  }

  if (loading) {
    return (
      <div data-testid="forecast-table-ratings-loading" className={styles.wrapper}>
        <Divider orientation="vertical" className={styles.emptyRatingsBar} />
      </div>
    );
  }

  return (
    <div data-testid="forecast-table-ratings-cell" className={styles.wrapper}>
      <Divider
        data-testid="forecast-table-ratings-empty"
        orientation="vertical"
        className={styles.emptyRatingsBar}
      />
    </div>
  );
};

export default RatingsCell;
